export const basicDetailsOCRStyles = {
  root: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 'calc(100vh - 148px)',
  },
  embeddedRoot: {
    bgcolor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 'auto',
  },
  content: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    p: 2,
    flex: 1,
  },
  embeddedContent: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    p: 2,
    flex: 1,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  stepText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.38)',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  titleRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'flex-start',
  },
  titleText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.15px',
  },
  requiredText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#c62828',
  },
  subtitleText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  fieldSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  fieldLabelRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
  },
  fieldLabel: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0,0,0,0.87)',
  },
  establishmentSelect: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    px: 2,
    border: '1px solid rgba(0,0,0,0.23)',
    borderRadius: '8px',
    bgcolor: 'white',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: 'rgba(0,0,0,0.02)',
    },
  },
  establishmentValue: (hasValue: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: hasValue ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.38)',
  }),
  textFieldRoot: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  personIcon: {
    color: 'rgba(0,0,0,0.54)',
    fontSize: 22,
  },
  manualPanInputStyle: {
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontFamily: "'Noto Sans', sans-serif",
  },
  successRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'flex-start',
  },
  successIcon: {
    color: '#0EA01A',
    fontSize: 20,
    mt: '2px',
  },
  successText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: '#007d00',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  successNameText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color: '#007d00',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  warningRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'flex-start',
  },
  warningIcon: {
    color: '#0f7575',
    fontSize: 20,
    mt: '2px',
  },
  warningText: {
    color: '#005E62',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '14px',
    fontStyle: 'normal', 
    fontWeight: 400,
    lineHeight: '143%', 
    letterSpacing: '0.17px',
  },
  warningNameText: {
    color: 'var(--info-dark, #005E62)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: 'var(--font-size-0875-rem, 14px)',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  errorRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'flex-start',
  },
  errorIconWrap: {
    mt: '5px',
    display: 'flex',
  },
  errorText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: '#b71b1c',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  tds10Notice: {
    borderRadius: '8px',
    bgcolor: '#f4f4f4',
    px: 2,
    py: 1,
  },
  tds10NoticeText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    color: '#333',
  },
  tds10Link: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 12,
    color: '#007cbf',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  tds20Notice: {
    borderRadius: '8px',
    bgcolor: '#fff8e1',
    px: 2,
    py: 1,
    borderLeft: '4px solid #f9a825',
  },
  tds20NoticeText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    color: '#5d4037',
  },
  tds20Link: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 12,
    color: '#5d4037',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  ocrStatusRow: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
  },
  ocrSuccessIcon: {
    color: '#0EA01A',
    fontSize: 24,
  },
  ocrStatusText: (color: string) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color,
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  }),
  ocrNameText: (color: string) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color,
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  }),
  retryText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    color: '#b71b1c',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
    mt: 0.5,
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    bgcolor: 'white',
    p: 2,
    borderTop: '1px solid #e3e6e9',
  },
  inlineFooter: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1200,
    width: '100%',
    bgcolor: 'white',
    p: 2,
    pb: 'max(16px, env(safe-area-inset-bottom))',
    // borderTop: '1px solid #e3e6e9',
  },
  nextButton: (enabled: boolean) => ({
    bgcolor: enabled ? '#007cbf' : 'rgba(0,0,0,0.12)',
    height: 42,
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: enabled ? 'pointer' : 'not-allowed',
    '&:hover': {
      bgcolor: enabled ? '#006aa8' : 'rgba(0,0,0,0.12)',
    },
  }),
  verifyButton: (loading: boolean) => ({
    bgcolor: loading ? 'rgba(0,0,0,0.12)' : '#007cbf',
    height: 42,
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    cursor: loading ? 'not-allowed' : 'pointer',
    '&:hover': {
      bgcolor: loading ? 'rgba(0,0,0,0.12)' : '#006aa8',
    },
  }),
  buttonText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: 'white',
    letterSpacing: '0.46px',
  },
  tdsModalPaper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  tdsModalContainer: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pb: 3,
    pt: 2,
    px: 2,
    borderRadius: '16px 16px 0 0',
  },
  tdsModalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pb: 0,
  },
  tdsModalTitle: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 18,
    color: 'rgba(0,0,0,0.87)',
    letterSpacing: '0.15px',
  },
  modalCloseButton: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    '&:hover': {
      bgcolor: 'rgba(0,0,0,0.04)',
    },
  },
  modalBodyText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: '#333',
    lineHeight: 1.75,
  },
};